<div class="layout-footer flex flex-row align-items-stretch flex-wrap">

    <p-card  class="col-12 md:col-6">
        <ng-template pTemplate="header">
            <div>
                <h5 class="mt-4 ml-4 mr-4 pt-4">Doctorium S.r.l.</h5>
            </div>
        </ng-template>
        <div>
            <div class="pr-2 pl-2 pb-2 mb-2 text-start">
                <p>{{ 'P.IVA' | translate }}: 03504140793<br>
                {{ 'E-mail' | translate }}: info&#64;doctorium.it<br>
                    {{  'PEC' | translate }}: doctorium&#64;pec.it</p>
                <p>{{ 'Seguici su' | translate }}: <br>
                    <a target="_blank" href="https://www.facebook.com/doctoriummedicalinstitute"><button pButton pRipple type="button" icon="pi pi-facebook" class="p-button-rounded p-button-text p-button-plain"></button></a>
                    <a target="_blank" href="https://www.instagram.com/doctorium_iltuodottoreonline/"><button pButton pRipple type="button" icon="pi pi-instagram" class="p-button-rounded p-button-text p-button-plain"></button></a>
                    <a target="_blank" href="https://www.linkedin.com/company/64624592/admin/"><button pButton pRipple type="button" icon="pi pi-linkedin" class="p-button-rounded p-button-text p-button-plain"></button></a></p>            </div>


        </div>
    </p-card>
    <p-card  class="col-12 md:col-6">
        <ng-template pTemplate="header">
            <div>
                <h5 class="mt-4 ml-4 mr-4  pt-4">{{ 'Termini e condizioni' | translate }}</h5>
            </div>
        </ng-template>
        <div>
            <div class="pr-2 pl-2 pb-2 mb-2 text-start">
<ul class="p-0 m-0" style="list-style-type: none">
    <li class="mb-2"><a href="https://www.doctorium.it/condizioni-di-servizio-doctorium/" target="_blank">{{ 'Condizioni di Servizio Doctorium' | translate }}</a></li>
    <li class="mb-2"><a href="https://www.doctorium.it/privacy-policy/" target="_blank">{{  'Informativa Privacy' | translate  }}</a></li>
    <li class="mb-2"><a href="https://www.doctorium.it/informativa-e-consenso-informato/" target="_blank">{{ 'Informativa e consenso informato telemedicina' | translate}}</a></li>
    <li class="mb-2"><a href="/assets/doctorium_codice_autoregolamentazione_2025.pdf" target="_blank">{{ 'Codice di autoregolamentazione' | translate }}</a></li>

</ul>
            </div>


        </div>
    </p-card>


</div>
